export default __webpack_public_path__ + "static/team-36558231c2569dc0114350715f0b6df2.jpg";